import React from "react";
import {
  Box,
  Stack,
  Tooltip,
  IconButton,
} from "@mui/material";
import {
  ContentCopy as CopyIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ReactMarkdown from "react-markdown";

interface AgentResponseDisplayProps {
  finalResult: string;
  feedbackState: "up" | "down" | null;
  onCopy: () => void;
  onThumbsUp: () => void;
  onThumbsDown: () => void;
  onRetry: () => void;
  markdownComponents?: any;
}

const AgentResponseDisplay: React.FC<AgentResponseDisplayProps> = ({
  finalResult,
  feedbackState,
  onCopy,
  onThumbsUp,
  onThumbsDown,
  onRetry,
  markdownComponents,
}) => {
  return (
    <Box
      sx={{
        my: 1,
        px: 2,
        borderRadius: 1,
        maxWidth: "100%",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          lineHeight: 1.7,
          wordWrap: "break-word",
          overflowWrap: "break-word",
          maxWidth: "100%",
          "& img": { maxWidth: "100%", height: "auto" },
          "& pre": {
            overflow: "auto",
            maxWidth: "100%",
          },
          "& code": {
            wordBreak: "break-all",
          },
        }}
      >
        <ReactMarkdown components={markdownComponents}>{finalResult}</ReactMarkdown>
      </Box>

      {/* Interaction toolbar */}
      <Stack
        direction="row"
        spacing={0.5}
        sx={{ mt: 3, ml: -1, opacity: 0.7 }}
      >
        <Tooltip title="Copy">
          <IconButton size="small" onClick={onCopy}>
            <CopyIcon sx={{ fontSize: "1.2rem" }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Good response">
          <IconButton size="small" onClick={onThumbsUp}>
            {feedbackState === "up" ? (
              <ThumbUpIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "primary.main",
                }}
              />
            ) : (
              <ThumbUpOutlinedIcon sx={{ fontSize: "1.2rem" }} />
            )}
          </IconButton>
        </Tooltip>
        <Tooltip title="Bad response">
          <IconButton size="small" onClick={onThumbsDown}>
            {feedbackState === "down" ? (
              <ThumbDownIcon
                sx={{
                  fontSize: "1.2rem",
                  color: "primary.main",
                }}
              />
            ) : (
              <ThumbDownOutlinedIcon sx={{ fontSize: "1.2rem" }} />
            )}
          </IconButton>
        </Tooltip>
        <Tooltip title="Retry">
          <IconButton size="small" onClick={onRetry}>
            <RefreshIcon sx={{ fontSize: "1.2rem" }} />
          </IconButton>
        </Tooltip>
      </Stack>
    </Box>
  );
};

export default AgentResponseDisplay;
